import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';

const ForgotPasswordPage = lazy(() => import('~/components/User/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('~/components/User/ResetPasswordPage'));

export const RESET_PASSWORD_ROUTES: RouteObject[] = [
  {
    path: ':token',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <ResetPasswordPage />
      </Suspense>
    ),
  },
  {
    path: '',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <ForgotPasswordPage />
      </Suspense>
    ),
  },
];
